import React from 'react'
// import logoStyles from './logo.module.sass';

// import hoof from '../img/hoof.svg';
// import hoof from '../img/hoof_white.svg';
import hoof from '../img/hoof.svg';
// import hoof from '../img/hoof_test.svg';
// import logo from '../img/logo.svg';
// import logo_white from '../img/logo-white.svg';

const Hoof = ({addClass}) => (
  <svg className={addClass}>
    <use xlinkHref={`#${hoof.id}`} />
  </svg>
);

export default Hoof

// export default ({ slug }) => {

//   let logoClasses = [logoStyles.figure]
//   if (slug === 'home'){
//     logoClasses.push(logoStyles.home);
//   } 

//   return (
//     <a className={logoClasses.join(' ')} href="/">
//       <img src={hoof_white} alt="Truffle Pigs Logo" className={logoStyles.logo} />
//       <strong className={[logoStyles.truffle, logoStyles.name].join(' ')}>Truffle</strong>
//       <strong className={[logoStyles.pigs, logoStyles.name].join(' ')}>Pigs</strong>
//       <strong className={logoStyles.date}>EST. 2000</strong>
//     </a>
//   );
// };